import React, { useState } from "react";
import { Box, Modal, ImageListItem, ImageListItemBar } from "@mui/material";
// import IconButton from "@mui/material/IconButton";
// import ExpandCircleDownIcon from "@mui/icons-material/ExpandCircleDown";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "auto",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export const CarouselComponent = ({ arrPicture, caption, translate }) => {
  const [open, setOpen] = useState(false);
  const [picModal, setPicModal] = useState("");

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpenModal = (pic) => {
    setOpen(true);
    setPicModal(pic);
  };

  return (
    <Box
      component="div"
      sx={{
        position: "relative",
        p: "20px",
        minHeight: "250px",
        cursor: "pointer",
      }}
    >
      <Carousel responsive={responsive}>
        {arrPicture.map((item, i) => (
          <Box
            key={i}
            component="div"
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "transparent",
              p: "10px",
            }}
            elevation={0}
            onClick={() => handleOpenModal(item)}
          >
            <img src={item} alt={item} width="100%" height="250px" />
          </Box>
        ))}
      </Carousel>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <ImageListItem key={picModal}>
            <img
              src={`${picModal}?w=248&fit=crop&auto=format`}
              srcSet={`${picModal}?w=248&fit=crop&auto=format&dpr=2 2x`}
              alt={picModal}
              loading="lazy"
            />
            <ImageListItemBar
              title={translate(`${caption}`)}
              position="below"
              sx={{ my: 1 }}
            />
          </ImageListItem>
        </Box>
      </Modal>
    </Box>
  );
};
